// Mirrors AdminRoute.jsx exactly, but for garage-tenant sessions. Kept as a
// separate component (not a shared "role" prop on AdminRoute) because the two
// sessions are entirely independent credential stores — see ../api/garageAuth
// vs ../api/auth — and mixing them into one component invites a bug where an
// admin session accidentally satisfies a garage-only route, or vice versa.
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isGarageAuthenticated, logoutGarage, validateGarageSession } from "../api/garageAuth";

export default function GarageRoute({ children }) {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let active = true;
    const onUnauthorized = () => {
      logoutGarage();
      setIsAuthenticated(false);
    };
    window.addEventListener("garage-unauthorized", onUnauthorized);

    if (!isGarageAuthenticated()) {
      setIsChecking(false);
      return () => window.removeEventListener("garage-unauthorized", onUnauthorized);
    }

    validateGarageSession().then((valid) => {
      if (!active) return;
      if (!valid) logoutGarage();
      setIsAuthenticated(valid);
      setIsChecking(false);
    }).catch(() => {
      if (!active) return;
      logoutGarage();
      setIsChecking(false);
    });

    return () => {
      active = false;
      window.removeEventListener("garage-unauthorized", onUnauthorized);
    };
  }, []);

  if (isChecking) return <div aria-busy="true" />;

  if (!isAuthenticated) {
    return <Navigate to="/garage-login" replace state={{ from: location.pathname }} />;
  }

  return children;
}